import snakecaseKeys from 'snakecase-keys'

const validate = traits => {
  if (typeof traits !== 'object') {
    throw new TypeError(`Expected traits to be an object, got ${typeof traits}`)
  }

  Object.keys(traits).forEach(key => {
    if (
      typeof traits[key] !== 'string' &&
      typeof traits[key] !== 'number' &&
      typeof traits[key] !== 'boolean' &&
      !Array.isArray(traits[key])
    ) {
      throw new TypeError(
        `Expected ${key} to be string, boolean, number or array, got ${typeof traits[
          key
        ]}`
      )
    }
  })
}

export const track = (title, traits) => {
  validate(traits)

  window.analytics.track(title, snakecaseKeys(traits))
}

export const page = (title, traits) => {
  validate(traits)

  window.analytics.page(title, snakecaseKeys(traits))
}
